import {EmailsSettings} from "./emails-settings";

export class EmailsSettingsMapper {
  public static map(data: any): EmailsSettings {
    let email: EmailsSettings = new EmailsSettings();
    email.id = data.id;
    email.description = data.description;
    email.value = data.value;
    email.default = data.default;
    email.tip = data.tip;
    email.label = data.label;
    return email;
  }

}
